
const routes = [


  {
    path: '/generalregistrosempresa',
    name: 'generalregistrosempresa',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/GeneralRegistrosEmpresaSistema.vue'),
    props: true,
  },
  {
    path: '/dashboardempresa',
    name: 'dashboardempresa',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/DashBoardEmpresaSistema.vue')
  },
  {
    path: '/conciliacioncontable',
    name: 'conciliacioncontable',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Admin/ConciliacionContableSistema.vue')
  },
  {
    path: '/listusers',
    name: 'listusers',
    component: () => import(/* webpackChunkName: "empresa" */ '@/views/Configuracion/ListUsersSistema.vue')
  },
];

export default routes.map(route => {
  return { ...route, meta: { public: false, admin:false, adminSagrilaft:true, adminCumplimiento:false, tercero:false } }
})